import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import mixpanelEvents from '@Mixpanel';
import { setExtractionsFlags } from '@Actions/filterActions';
import { forms } from 'seal-ui-components';
import { CheckBoxFilterDiv, InBodyTitle, StyledCheckBoxWrapper } from '../ScoreCardFilters.style';

const ExtractionsFilter = () => {
    const dispatch = useDispatch();

    const { extractionFlagsInput } = useSelector(state => state.scoreCardFilters);

    const handleExtractionsFlags = key => {
        extractionFlagsInput[key].selected = !extractionFlagsInput[key].selected;

        dispatch(setExtractionsFlags(extractionFlagsInput));
        mixpanelEvents.scorecardFiltersApplied();
    };

    return (
        <CheckBoxFilterDiv>
            <InBodyTitle>Has extractions:</InBodyTitle>
            <StyledCheckBoxWrapper style={{ marginLeft: '9px' }}>
                {Object.values(extractionFlagsInput).map((extraction, idx) => (
                    <forms.CheckboxField
                        key={`extractions_${idx}`}
                        label={extraction.text}
                        onChange={() => handleExtractionsFlags(extraction.text)}
                        checked={extraction.selected}
                    />
                ))}
            </StyledCheckBoxWrapper>
        </CheckBoxFilterDiv>
    );
};

export default ExtractionsFilter;
